<template>
  <div class="checkbox" :class="{ 'has-error': hasError }">
    <label>
      <input
        type="checkbox"
        :value="value"
        :class="className"
        :disabled="disabled"
        @change="onChange"
        :checked="state"
      >
      {{ label }}
    </label>
    <span class="help-block" v-if="hasError">{{ errors[0] }}</span>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    modelValue: {
      default: undefined,
    },
    className: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    state() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.value) > -1;
      }
      return !!this.modelValue;
    },
    hasError() {
      return this.errors && this.errors.length;
    },
  },
  methods: {
    onChange() {
      this.toggle();
    },
    toggle() {
      let value;
      if (Array.isArray(this.modelValue)) {
        value = this.modelValue;
        if (this.state) {
          value.splice(value.indexOf(this.value), 1);
        } else {
          value.push(this.value);
        }
      } else {
        value = !this.state;
      }
      this.$emit('input', value);
    },
  },
};
</script>
